module.exports = __webpack_public_path__ + "img/BarreraUp.8456442d.png";